import React from "react";
import "../Services/Services.css";
import Service from "../Service/Service";

const Services = () => {
 

  return (
    <section
      className={`services`}
      id="services"
    >
      <div className="service-text">
        <h1>My Offered Services</h1>
        <br />
        <span>
          Using the latest technologies to showcase your business or a complex
          web application with all the bells and whistles, I can help you create
          a digital platform that meets your needs and exceeds your
          expectations.
        </span>
      </div>

      <div className="allServices">
        <Service
          serv_name="Web Development"
          desc="Create interactive, static & dynamic, user-friendly Web applications with the best UX using React-Js, Next-Js, WordPress, and Shopify"
          clas="fa fa-laptop"
        />
        <Service
          serv_name="Photography"
          desc="““Do you want to be even more successful? Learn to love learning and growth. The more effort you put into improving your skills.”"
          clas="fa fa-camera"
        />
        <Service
          serv_name="Graphic Design"
          desc="Crafting the bestest Designs for your branding cards, Logos, Business Cards, and many more using Top-trending Graphics Designing tools. "
          clas="fa fa-rocket"
        />
      </div>
    </section>
  );
};

export default Services;
